import { downloadFile, downloadFileWithName } from "api-operations/common";
export async function downloadTCertFile(jobId) {
    await downloadFile(`/api/v2/jobs/${jobId}/outputZip`, { fileType: 'TCERT' });
}
export async function downloadProjectSummary(jobId, jobName) {
    await downloadFileWithName(`/api/workflow/requester/jobs/${jobId}/csv`, {}, jobName + '_project_summary.csv');
}
